module.exports = "/static/js/0e5c7aaeca7e812e07e83dc770d8cb37.png";